// test1379
(1379 && 0);
